<template>
  <v-btn
    v-bind="$attrs"
    class="subtitle-2 font-weight-bold px-3"
    color="primary"
    text
    tile
    :height="height"
    @click="onClick"
  >
    <ekitabu-icon
      size="14"
      class="gradient-text mr-1"
      style="transform: rotate(-90deg);"
    >
      mdi-triangle
    </ekitabu-icon>
    <span class="gradient-text">
      {{ text }}
    </span>
  </v-btn>
</template>

<script>
import i18n from '@/i18n';

export default {
  name: "ContinueShopping",
  props: {
    handleClick: {
      type: Function,
      default: null,
    },
    height: {
      type: String,
      default: "30px",
    },
    text: {
      type: String,
      default: i18n.t("shop.continueShopping"),
    },
  },
  methods: {
    onClick() {
      if (this.handleClick) {
        this.handleClick();
      } else {
        this.$router.go(-1);
      }
    },
  },
}
</script>

<style scoped lang="scss">
.gradient-text {
  background: $primary-gradient;
}
</style>